import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './deals-list-filter-year.component.scss';
var DealsListFilterYear = /** @class */ (function (_super) {
    tslib_1.__extends(DealsListFilterYear, _super);
    function DealsListFilterYear(element) {
        return _super.call(this, element) || this;
    }
    DealsListFilterYear.prototype.init = function () { };
    ;
    DealsListFilterYear.prototype.bindEvents = function () { };
    ;
    return DealsListFilterYear;
}(Base));
export { DealsListFilterYear };



//////////////////
// WEBPACK FOOTER
// ./components/deals-list-filter-year/deals-list-filter-year.component.ts
// module id = 258
// module chunks = 0